import React                   from 'react';
import { connect }             from 'react-redux';
import { reducerType }         from 'reducer';
import { 
  getPage,
  autoPageChange 
}                              from '../pages';
import DroppableUnit           from './DroppableUnit';
import Button                  from 'components/buttons/DisplayEggBoxButton';
import ReduceTensButton        from 'components/buttons/ReduceTensButton';
import sizes                   from 'utils/sizes';
import words                   from 'utils/words';
import { makeStyles  }         from "makeStyles";
import { componentsStateType } from 'reducer/types';
import { objType }             from 'types';

var clsx = require('classnames')

const hebText = 'בשלב זה מציגים באמצעות תבניות וביצים את המספר הנתון';
const hebText2 = 'יש להניח תבניות סגורות בצד שמאל ותבניות פתוחות בצד ימין'
const hebText3 = 'ניתן להשתמש בכפתור "10-" על מנת לחסר תבניות מלאות'


const useStyles = makeStyles()(
    (Theme) => ({
        root: {
          display:    'flex',
          alignItems: 'center',
          flexFlow:   'column',
        },
        title: {
          height:         45,
          display:        'flex',
          alignItems:     'center',
          justifyContent: 'center',
          color:          Theme.darkBlue,
          fontSize:       Theme.normalFont
        },
        droppable: {
            display:        'flex',
            alignItems:     'center',
            justifyContent: 'space-evenly',
            border:         `1px solid #CCC`,
            borderRadius:   '0.5em',
            transition:     'all 0.3s'
        },
        submit: {
          width:           '100%',
          maxWidth:        350,
          display:         'flex',
          alignItems:      'center',
          justifyContent:  'center',
          borderRadius:    '0.5em',
          backgroundColor: Theme.green,
          color:           '#FFF',
          cursor:          'pointer',
          fontWeight:      'bold',
          boxShadow:       Theme.buttonShadow,
          '&:hover': {
              backgroundColor: Theme.darkGreen,
          }
      },
      buttonContainer: {
        position:       'absolute',
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        width:          50,
        height:         50,
        borderRadius:   '50%',
        transition:     'all 0.3s',
      },
      shake: {
        animation:               'shake 0.4s',
       // animationIterationCount: 'infinite',
      } 
    }),
);

type DroppablePropsType = {
    size:              number[];
    question:          number;
    pageNum:           number;
    tensVal:           number;
    wideScreen:        boolean;
    feedBack:          string;
    componentsState:   componentsStateType;
    finalPositions:    boolean[];
    droppablePos0:     objType;
    droppablePos1:     objType;
    setDroppablePos0:  (val: objType) => void;
    setDroppablePos1:  (val: objType) => void;
    setFinalPositions: (val: boolean[]) => void;
    nextPage:          () => void;
  
    
}

const Droppable: React.FC<DroppablePropsType> = ({ 
  size, 
  question, 
  pageNum,
  tensVal,
  wideScreen,
  feedBack,
  componentsState,
  droppablePos0,
  droppablePos1,
  finalPositions,
  setDroppablePos0,
  setDroppablePos1,
  setFinalPositions,
  nextPage
 }) => {

    const { classes } = useStyles();

   

    const [num1, num2] = React.useMemo(() => {

      if (!question) {
          return [0,0]
      }
      if ( question < 10 ) {
          return [0, question];
      }
      return [Math.floor(question/10), question%10]
    },[question])



    const shake = React.useMemo(() => {
       return pageNum === getPage('returnTen0')
    },[pageNum])
    


    const [rootStyle, droppableStyle, submitStyle, buttonStyle, buttonStyle2] = React.useMemo(() => {

      const { bigBoxHeight, smallBoxHeight, bigBoxGap, smallBoxGap } = sizes;
      const boxHeight    = wideScreen ? bigBoxHeight : smallBoxHeight;
      const BoxGap       = wideScreen ? bigBoxGap : smallBoxGap;
      const width        = wideScreen ? sizes.bigBoxWidth * 2.5 : size[0]/2;
      const defaulHeight = tensVal < 2;
      const height       = defaulHeight ? boxHeight : boxHeight + (tensVal * BoxGap);
      const gap          = wideScreen ? bigBoxGap : smallBoxGap;
      const trans        = tensVal///pageNum <= getPage('dragTen1') ? 0 : tensVal;

      return [
        {
          width:        width,
          height:       wideScreen ? sizes.bigBoxHeight * 5 : undefined,
          marginLeft:   wideScreen ? 40 : undefined,
          marginRight:  wideScreen ? 40 : undefined,
          justifyContent:   wideScreen ? 'space-between' : 'center',
        },
        {
          marginBottom: wideScreen ? undefined : 30,
          width:        width,
          height:       height + 40
        },
        {
          marginTop:    wideScreen ? 20 : -15,
          marginBottom: wideScreen ? undefined : 8,
          height:       wideScreen ? 45 : 35,
          opacity:      autoPageChange.includes(pageNum) ? 0.5 : 1
        },
        {
          transform: `translate(${ -width/2 - 10 }px, -${ (height / 2) + ((trans) * gap) / 2 }px)`,
        },
        {
          transform: `translate(${  -width/2 -10 }px, -${ ((height / 2) + ((trans) * gap) / 2) - 50 }px)`,
          border:    '3px solid #F00'
        }
      ]
    },[wideScreen, tensVal, pageNum, size])
   

    return(
      <div 
         className = { shake ? clsx(classes.root, classes.shake) : classes.root }
         style     = { rootStyle }
      >
              
             <div 
                dir       = 'rtl'
                className = { classes.title }
                style     = {{ width: wideScreen ? '100%' : '85vw' }}
             >
                { pageNum === getPage('dragTen4') ? hebText3 : pageNum === getPage('returnTen0') ? hebText2 : hebText } 
             </div>

             <div 
                 className = { classes.droppable }
                 style     = { droppableStyle }
             >
                  <div 
                    className = { classes.buttonContainer }
                    style     = { buttonStyle }
                  >
                    {
                        pageNum > getPage('typeInput2') &&
                        <Button
                          variant    = { 'mazeget' }
                          value      = { pageNum - 4 }
                          wideScreen = { wideScreen }
                        />
                    }
                </div>
                {
                      tensVal === 4 &&
                      <div 
                          className = { classes.buttonContainer }
                          style     = { buttonStyle2 }
                      >
                        <ReduceTensButton
                          variant    = { 'mazeget' }
                          value      = { componentsState.tens.value }
                          wideScreen = { wideScreen }
                        />
                      </div>
                }
                {
                  num1 > 0 &&
                  <DroppableUnit 
                    variant           = 'tens'
                    value             = { tensVal }
                    wideScreen        = { wideScreen }
                    correctVal        = { num1 }
                    pageNum           = { pageNum }
                    finalPositions    = { finalPositions }
                    droppablePos0     = { droppablePos0 }
                    droppablePos1     = { droppablePos1 }
                    setDroppablePos0  = { setDroppablePos0 }
                    setDroppablePos1  = { setDroppablePos1 }
                    setFinalPositions = { setFinalPositions }
                  />
                }
                  <DroppableUnit 
                    variant           = 'units'
                    value             = { -1 }
                    wideScreen        = { wideScreen }
                    correctVal        = { num2 }
                    pageNum           = { pageNum }
                    finalPositions    = { finalPositions }
                    droppablePos0     = { droppablePos0 }
                    droppablePos1     = { droppablePos1 }
                    setDroppablePos0  = { setDroppablePos0 }
                    setDroppablePos1  = { setDroppablePos1 } 
                    setFinalPositions = { setFinalPositions }
                  />
             </div>
             <div 
                className = { classes.submit }
                style     = { submitStyle }
                onClick   = { autoPageChange.includes(pageNum) ? () => {} : nextPage }
             >
                { pageNum < getPage('dragUnits1') ? words.continue :  words.goToTirgul }
             </div>
      </div>
    )
}

  const mapStateToProps = (reducer: reducerType) => {
    return {
      componentsState: reducer.components
    }
  };

  export default connect(mapStateToProps)(Droppable);
  
  
  